/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_HoldInputs */

const en_create_hold = /** @type {(inputs: Create_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Hold`)
};

const es_create_hold = /** @type {(inputs: Create_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear apartado`)
};

/**
* | output |
* | --- |
* | "Create Hold" |
*
* @param {Create_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_hold = /** @type {((inputs?: Create_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_hold(inputs)
	return es_create_hold(inputs)
});